import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-corner-left-bottom",
  "use": "icon-corner-left-bottom-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-corner-left-bottom\"><path d=\"M.5 0v11h11\" stroke=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol